import React, { useContext } from 'react';

import { FlagsContext } from 'src/context/flagsContext';
import Layout, { LayoutProps } from 'src/legacy/components/Layout';
import { HeaderSlotContext } from 'src/legacy/components/Layout/AppShell/HeaderSlotContext';

import { SettingsPageHeaderTitle } from './SettingsPageHeaderTitle';

/**
 * Thin shim used when EnableNewAppLayout is ON.
 * Sets the header slot (using headerComponent if provided, otherwise
 * <SettingsPageHeaderTitle />) and renders children in a height-filling
 * wrapper so descendant h-full / height:100% chains resolve correctly.
 */
const SettingsLayoutShim: React.FC<{
  children?: React.ReactNode;
  headerComponent?: React.ReactNode;
}> = ({ children, headerComponent }) => {
  const headerSlotCtx = useContext(HeaderSlotContext);

  React.useEffect(() => {
    if (!headerSlotCtx) return;
    headerSlotCtx.setHeader(headerComponent ?? <SettingsPageHeaderTitle />);
    return () => {
      headerSlotCtx.clearHeader();
    };
  }, [headerSlotCtx, headerComponent]);

  return <div className="h-full w-full">{children}</div>;
};

export const SettingsLayout: React.FC<Partial<LayoutProps>> = ({
  children,
  headerComponent,
  ...others
}) => {
  const { EnableNewAppLayout } = useContext(FlagsContext);

  if (EnableNewAppLayout) {
    return (
      <SettingsLayoutShim headerComponent={headerComponent}>
        {children}
      </SettingsLayoutShim>
    );
  }

  return (
    <Layout
      title={<SettingsPageHeaderTitle />}
      showNavbarAuthActions={false}
      headerComponent={headerComponent}
      {...others}
    >
      {children}
    </Layout>
  );
};
